import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { format } from "timeago.js";
import * as React from "react";
import { ProStore } from "@redocly/reference-docs";
import { withTheme, ThemeContext } from "../styled-components";
import { StyledContent } from "../components/StyledContent/StyledContent";
import TableOfContent from "../components/TableOfContent/TableOfContent";
import UserMarkdownLayout from "../components/UserComponents/layouts/Markdown";
import { sanitizeDefinitionId } from "../../utils/utils";
import { getHooks } from "../templates/get-hooks";
import StepByStepWrapper from "../components/mdx/StepByStepWrapper";
var LS_SNIPPETS_LANG = "redocly_snippetsLang",
    CACHED_STORES = {};
export var RedocStoresContext = /*#__PURE__*/React.createContext({});

function getStoreStateById(a, b) {
  var c = (a["__oasDef_" + sanitizeDefinitionId(b)] || {}).redocStoreStr,
      d = c && JSON.parse(c) || void 0;
  return d;
}

function constructStoreFromPageData(a, b, c) {
  var d = CACHED_STORES[c];

  if (!d) {
    var e = getStoreStateById(a, c),
        f = getHooks();
    if (!e) return null;
    e.options = e.options || {}, e.options.disableSearch = !0, e.options.ctrlFHijack = !1, e.options.showNextButton = !1, e.options.disableSidebar = !0, e.options.disableDeepLinks = !0, e.options.theme = b, e.options.showConsole = e.options.showConsole || !0, e.options.hooks = f, d = ProStore.fromJS(e), CACHED_STORES[c] = d;
  }

  return d;
}

var GetStoreInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GetStoreInner, _React$Component);

  function GetStoreInner() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = GetStoreInner.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/React.createElement(RedocStoresContext.Consumer, null, function (a) {
      var b = constructStoreFromPageData(a, _this.props.theme, _this.props.definitionId);
      return b ? _this.props.children(b) : /*#__PURE__*/React.createElement("pre", {
        style: {
          color: "red"
        }
      }, "Incorrect definitionId: \"", _this.props.definitionId, "\"");
    });
  };

  return GetStoreInner;
}(React.Component);

export var GetStore = withTheme(GetStoreInner);
export function useOasDefinitionStore(a) {
  var b = React.useContext(ThemeContext),
      c = React.useContext(RedocStoresContext);
  return constructStoreFromPageData(c, b, a);
}
export function useOasDefinition(a) {
  var _getStoreStateById, _getStoreStateById$de;

  var b = React.useContext(RedocStoresContext);
  return ((_getStoreStateById = getStoreStateById(b, a)) === null || _getStoreStateById === void 0 ? void 0 : (_getStoreStateById$de = _getStoreStateById.definition) === null || _getStoreStateById$de === void 0 ? void 0 : _getStoreStateById$de.data) || null;
}
export default function MarkdownLayout(a) {
  var _React$useState = React.useState(null),
      b = _React$useState[0],
      c = _React$useState[1],
      d = React.useCallback(function (a) {
    c(a);
  }, []);

  React.useEffect(function () {
    if (!b) return function () {
      return void 0;
    };
    if (b !== null && b !== void 0 && b.addEventListener("click", onSnippetTabClick), a.location.hash) switchSnippetsLang(a.location.hash.substring(1));else {
      var _a = window.localStorage && window.localStorage.getItem(LS_SNIPPETS_LANG);

      _a && switchSnippetsLang(_a);
    }
    return function () {
      return b === null || b === void 0 ? void 0 : b.removeEventListener("click", onSnippetTabClick);
    };
  }, [b]);
  var e = a.html,
      f = a.data,
      g = a.location,
      h = a.pageContext,
      i = f.contentItem && f.contentItem.data.lastModified,
      j = isTocEnabled(h),
      k = h.toc && h.toc.headings,
      l = {};

  for (var _b in f) {
    _b.startsWith("__oasDef_") && (l[_b] = f[_b]);
  }

  var m = null == e ? /*#__PURE__*/React.createElement(StyledContent, {
    ref: d
  }, a.children) : /*#__PURE__*/React.createElement(StyledContent, {
    ref: d,
    dangerouslySetInnerHTML: {
      __html: e || ""
    }
  }),
      n = h.data || {},
      o = h.pageId || "";
  return /*#__PURE__*/React.createElement(RedocStoresContext.Provider, {
    value: l
  }, /*#__PURE__*/React.createElement(StepByStepWrapper, null, /*#__PURE__*/React.createElement(UserMarkdownLayout, {
    location: g,
    headings: k,
    contentWrapper: b,
    Toc: function Toc() {
      var _h$toc;

      return j ? /*#__PURE__*/React.createElement(TableOfContent, {
        headings: k,
        tocMaxDepth: h === null || h === void 0 ? void 0 : (_h$toc = h.toc) === null || _h$toc === void 0 ? void 0 : _h$toc.maxDepth,
        contentWrapper: b
      }) : null;
    },
    withToc: j,
    lastModified: !disableLastModified(f) && i || void 0,
    lastModifiedAgo: i && !disableLastModified(f) ? format(i) : void 0,
    frontmatter: n,
    pageId: o
  }, m)));
}

function onSnippetTabClick(a) {
  if (a.target.classList.contains("tab-header") && a.target.parentElement.classList.contains("snippets-tabs-headers")) {
    var b = a.target.dataset.snippetId || a.target.dataset.lang;
    history.pushState(null, "", "#" + b), switchSnippetsLang(b);
  }
}

function switchSnippetsLang(a) {
  function b(a, b) {
    if (a) {
      for (var _iterator = _createForOfIteratorHelperLoose(a), _step; !(_step = _iterator()).done;) {
        var _c = _step.value;
        _c.dataset.snippetId === b ? _c.classList.add("active") : _c.classList.remove("active");
      }
    }
  }

  var c = document.querySelectorAll("[data-snippet-id=\"" + a + "\"]");
  window.localStorage && window.localStorage.setItem(LS_SNIPPETS_LANG, a);

  for (var _iterator2 = _createForOfIteratorHelperLoose(c), _step2; !(_step2 = _iterator2()).done;) {
    var _d$parentElement;

    var d = _step2.value;
    b((_d$parentElement = d.parentElement) === null || _d$parentElement === void 0 ? void 0 : _d$parentElement.children, a);
  }
}

export function isTocEnabled(a) {
  var _b$;

  if (!a) return !1;
  var b = a.toc && a.toc.headings,
      c = b && b.some(function (a) {
    return 4 >= a.depth;
  }),
      d = 1 === (b === null || b === void 0 ? void 0 : b.length) && 1 === ((_b$ = b[0]) === null || _b$ === void 0 ? void 0 : _b$.depth);
  return c && !d && (a.toc && a.toc.enable || !1);
}
export function disableLastModified(a) {
  if (!a) return !1;
  var b = a.contentItem && a.contentItem.data.disableLastModified,
      c = a.siteConfig && a.siteConfig.disableLastModified;
  return !1 !== b && (b || c);
}